import { useMutation } from "@tanstack/react-query";
import { useQueryApi } from "api/hooks";

import { processRefuseLeadSettingsApi } from "./api";

import GetProcessRefuseLeadSettingRequest = App.Http.Requests.RefuseLeadSettings.GetRefuseLeadSettingRequest;
import GetProcessRefuseLeadSettingsRequest = App.Http.Requests.RefuseLeadSettings.GetRefuseLeadSettingsRequest;
import GetProcessRefuseLeadSettingResponse = App.Http.Responses.RefuseLeadSettings.GetProcessRefuseLeadSettingResponse;
import GetProcessRefuseLeadSettingsResponse = App.Http.Responses.RefuseLeadSettings.GetProcessRefuseLeadSettingsResponse;
import StoreProcessRefuseLeadSettingRequest = App.Http.Requests.RefuseLeadSettings.StoreRefuseLeadSettingRequest;
import UpdateProcessRefuseLeadSettingRequest = App.Http.Requests.RefuseLeadSettings.UpdateRefuseLeadSettingRequest;

export const useGetProcessRefuseLeadSettings = (
    offerId: string,
    request: GetProcessRefuseLeadSettingsRequest,
    options = {}
) => {
    return useQueryApi<GetProcessRefuseLeadSettingsResponse>({
        queryKey: ["getProcessRefuseLeadSettings", offerId, request],
        queryFn: () => processRefuseLeadSettingsApi.index(offerId, request),
        ...options,
    });
};

export const useGetProcessRefuseLeadSetting = (
    offerId: string,
    refuseLeadSettingId: string,
    request: GetProcessRefuseLeadSettingRequest,
    options = {}
) => {
    return useQueryApi<GetProcessRefuseLeadSettingResponse>({
        queryKey: ["getProcessRefuseLeadSetting", offerId, refuseLeadSettingId, request],
        queryFn: () => processRefuseLeadSettingsApi.show(offerId, refuseLeadSettingId, request),
        ...options,
    });
};

export const useStoreProcessRefuseLeadSettingMutation = (offerId: string) => {
    return useMutation({
        mutationFn: (request: StoreProcessRefuseLeadSettingRequest) => processRefuseLeadSettingsApi.store(offerId, request),
    });
};

export const useUpdateProcessRefuseLeadSettingMutation = (offerId: string, refuseLeadSettingId: string) => {
    return useMutation({
        mutationFn: (request: UpdateProcessRefuseLeadSettingRequest) =>
            processRefuseLeadSettingsApi.update(offerId, refuseLeadSettingId, request),
    });
};

export const useDestroyProcessRefuseLeadSettingMutation = (offerId: string, refuseLeadSettingId: string) => {
    return useMutation({
        mutationFn: () => processRefuseLeadSettingsApi.destroy(offerId, refuseLeadSettingId),
    });
};
